<button (click)="goBack()" class="flex items-center gap-2 font-semibold cursor-pointer text-slate-400 max-w-fit">
  <app-icon icon="arrow-left.svg" color="slate-400" [width]="iconWidth"></app-icon>
  {{ text | translate }}
</button>
